// extracted by mini-css-extract-plugin
export default {"colorScheme":"ColorSchemeToggle_colorScheme__xsA9O"};